import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const SectionHeader = ({ icon: Icon, title, subtitle }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
        <Box
            sx={{
                width: 36,
                height: 36,
                borderRadius: 1.5,
                bgcolor: 'primary.main',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
            }}
        >
            <Icon sx={{ color: '#fff', fontSize: 18 }} />
        </Box>
        <Box>
            <Typography variant="subtitle1" fontWeight={700} lineHeight={1.2}>
                {title}
            </Typography>
            {subtitle && (
                <Typography variant="caption" color="text.secondary">
                    {subtitle}
                </Typography>
            )}
        </Box>
    </Box>
);

SectionHeader.propTypes = {
    icon: PropTypes.elementType.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string
};

SectionHeader.defaultProps = {
    subtitle: ''
};

export default SectionHeader;
